import React, {Fragment} from 'react';
import {Typography} from '@mui/material';
import {BookingTypeEnum} from 'presentation/pages/private/booking/constants';
import {formatDateString, formatText} from 'presentation/utils';
import {DateFormatEnum} from 'presentation/constants';
import {translations} from 'presentation/translations-new';
import {CancelDescriptionProps} from './types';

const {cancelDescription} = translations['pt-br'].privateFlow.bookingFlow;

export function CancelDescription({appointment, multipleBooking}: CancelDescriptionProps) {
	const {bookingType, date, specialtyName, providerName, hour} = appointment;
	const isExam = bookingType === BookingTypeEnum.EXAM;
	const isSurgery = bookingType === BookingTypeEnum.SURGERY;

	return (
		<Fragment>
			<Typography variant="body1" textAlign="center">
				{cancelDescription.cancel}{' '}
				{cancelDescription[bookingType as keyof typeof cancelDescription]}{' '}
				<b>{isExam || isSurgery ? formatText(specialtyName) : formatText(providerName)}</b>{' '}
				em <b>{formatDateString(date, DateFormatEnum.DATE_FORMAT_1, 'P')}</b> às{' '}
				<b>{hour}</b>
				{!isExam && !isSurgery ? (
					<Fragment>
						{' '}
						na especialidade <b>{formatText(specialtyName)}</b>
					</Fragment>
				) : null}
				?
			</Typography>
			{multipleBooking ? (
				<Typography variant="body1" textAlign="center">
					Não se preocupe, essa sessão poderá ser remarcada dentro do período autorizado.
				</Typography>
			) : null}
		</Fragment>
	);
}
